import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createPulmonologyRecord,
  deletePulmonologyRecord,
  fetchPulmonologyRecords,
  updatePulmonologyRecord,
} from "../redux/thunks/pulmonologyThunks";
import {
  selectPulmonologyError,
  selectPulmonologyLoading,
  selectPulmonologyPatientRecords,
  selectPulmonologySaving,
} from "../redux/selectors/pulmonologySelectors";

export default function usePulmonologyRecords(patientId) {
  const dispatch = useDispatch();
  const records = useSelector((state) => selectPulmonologyPatientRecords(state, patientId));
  const loading = useSelector(selectPulmonologyLoading);
  const saving = useSelector(selectPulmonologySaving);
  const error = useSelector(selectPulmonologyError);

  useEffect(() => {
    if (patientId) dispatch(fetchPulmonologyRecords({ patientId }));
  }, [dispatch, patientId]);

  const save = (resource, payload, options = {}) => {
    const id = options.id;
    const action = id
      ? updatePulmonologyRecord({ patientId, resource, id, payload })
      : createPulmonologyRecord({ patientId, resource, payload, documentId: options.documentId });
    return dispatch(action).unwrap();
  };

  const remove = (resource, id) =>
    dispatch(deletePulmonologyRecord({ patientId, resource, id })).unwrap();

  return { records, loading, saving, error, save, remove };
}